import prof from "../imgs/profil.jpg"
import lg from "../imgs/logo.jpg" 
import { useNavigate } from "react-router-dom";
const Footer = () => {
    const nav = useNavigate();
    return (
        <>
            <div className="foot mt-5">
                <div className="row">
                   <div className="col-lg-6">
                    <div className="container">
                       <div className="peof">
                        <img src={prof} width={"200px"} className="img-fluid" /> &nbsp; &nbsp; &nbsp; &nbsp;
                        <img src={lg} width={"200px"} className="img-fluid" /> <br/> <br/>
                        <div className="container sfot">
                        <h4> <i class="fa-solid fa-globe"></i> www.himanshuverse.com </h4>
                        <button className="btn btn-primary" onClick={()=>nav("https://www.linkedin.com/in/himanshu-kumar-a58860319/")}> Follow more on Linkdein </button>
                        </div>
                    </div>
                    </div>
                    </div> 
                <div className="col-lg-6">
                <div className="container">
                 
                    <table className="pt-5">
                        <tbody>
                            <tr>
                                <td>
                                    <ul>
                                        <li>  <h5> Usefull links </h5></li>
                                        <li> Home </li>
                                        <li> Shop </li>
                                        <li> Contact </li>
                                        <li> About </li>
                                    </ul>
                                </td>
                                <td>
                                <ul>
                                <li><h5> Contact us</h5> </li>
                                <li> <i class="fa-solid fa-phone"></i> 91-6284079093 </li>
                                <li> <i class="fa-solid fa-envelope"></i> himanshu@himanshuverse.com </li>
                                <li> <i class="fa-solid fa-envelope"></i> himanshucolleg@gmail.com </li>
                                <li> <i class="fa-brands fa-linkedin"></i> Himanshu Kumar </li>
                            </ul>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    
                </div>
                </div>
                </div>
</div>
        
        </>
    );
}

export default Footer;